import { render, staticRenderFns } from "./ViewSelectedTrade.vue?vue&type=template&id=05a86aa2&scoped=true&"
import script from "./ViewSelectedTrade.vue?vue&type=script&lang=js&"
export * from "./ViewSelectedTrade.vue?vue&type=script&lang=js&"
import style0 from "./ViewSelectedTrade.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ViewSelectedTrade.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./ViewSelectedTrade.vue?vue&type=style&index=2&id=05a86aa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../front.sfc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a86aa2",
  null
  
)

export default component.exports